import React from "react";
import { bool } from "prop-types";
import Block from "../Block";
import { classes } from "../utils/classes";

const Panel = ({ className = "", shadow, ...props }) => {
	return <Block className={classes("panel", shadow && "panel--shadow", className)} {...props} />;
};

Panel.propTypes = {
	shadow: bool,
	...Block.propTypes,
};

export default Panel;
